import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import { selectUserPrivateMoney } from '~/javascripts/admin/reducers/user-private-money';
import type { PrivateMoneyFormValues } from '..';
import FormErrorMessage from '../../../atoms/FormErrorMessage';
import Label from '../../../atoms/Label';
import Required from '../../../atoms/Required';
import OrganizationMoneySelect from '../../../molecules/OrganizationMoneySelect';

type Props = {
  mode: 'create' | 'edit';
  allowedInputs?: 'all' | (keyof PrivateMoneyFormValues)[];
};

const BaseMoneySelector = ({ mode, allowedInputs }: Props) => {
  const { control, watch } = useFormContext<PrivateMoneyFormValues>();

  const isInputAllowed = (name: keyof PrivateMoneyFormValues) =>
    allowedInputs === 'all' || allowedInputs?.includes(name);

  const currentMoney = useAppSelector(selectUserPrivateMoney);
  const organizationCode =
    mode === 'edit' ? currentMoney.organization?.code : watch('organization_code');

  return (
    <div style={{ marginTop: '12px' }}>
      <Label>
        ベースマネーの設定 <Required />
      </Label>
      <Controller
        name="fallback_private_money_uuid"
        control={control}
        rules={{ required: 'ベースマネーを選択してください' }}
        render={({ field: { onChange, value } }) => (
          <OrganizationMoneySelect
            organizationCode={organizationCode}
            value={value}
            onChange={onChange}
            excludeMoneyId={mode === 'edit' ? currentMoney.id : undefined}
            disabled={!isInputAllowed('fallback_private_money_uuid')}
          />
        )}
      />
      <FormErrorMessage name="fallback_private_money_uuid" />
    </div>
  );
};

export default BaseMoneySelector;
